export default function ({ store, redirect }) {
  console.log('using?');
  // if (process.client && !store.getters["isLoggedIn"])
  //   return redirect("/login");
}
